import { BookOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/assist/ui/button';

/**
 * Global header affordance (EL-569) that opens the glossary. Rendered in the
 * dashboard header so the glossary is reachable from any persona/page.
 */
export function GlossaryButton() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const label = t('glossary.nav');

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9"
      onClick={() => navigate('/glossary')}
      aria-label={label}
      title={label}
      data-testid="glossary-button"
    >
      <BookOpen className="h-4 w-4" />
    </Button>
  );
}
